export default __webpack_public_path__ + "static/media/pagebanner2.6b0ef921.jpg";